import request from '@/api/request.js';

// 代理商列表
export const getProxyList = (params) => {
    return request({
        url: '/base/adm/company/getProxyList',
        method: 'get',
        params
    })
}

// 分销商列表
export const getSubProxyList = (params) => {
    return request({
        url: '/base/adm/company/getSubProxyList',
        method: 'get',
        params
    })
}

// 公司详情
export const getCompanyInfo = (params) => {
    return request({
        url: '/base/adm/companyInfo/getCompanyInfo',
        method: 'get',
        params
    })
}

// 合作申请列表
export const getCooperationApplyListPage = (params) => {
    return request({
        url: '/base/adm/cooperationApply/getListPage',
        method: 'get',
        params
    })
}

// 合作单位申请详情
export const getCooperationApply = (params) => {
    return request({
        url: '/base/adm/cooperationApply/getCooperationApply',
        method: 'get',
        params
    })
}

// 更新合作申请
export const updateCooperationApply = (data) => {
    return request({
        url: '/base/adm/cooperationApply/updateCooperationApply',
        method: 'post',
        data
    })
}

// 获取合作项目介绍
export const getProjectContent = () => {
    return request({
        url: '/radioweb/adm/cooperationApply/getProductIntroduction',
        method: 'get'
    })
}

// 设置合作项目介绍
export const setProjectContent = (params) => {
    return request({
        url: '/radioweb/adm/cooperationApply/updateProductIntroduction',
        method: 'get',
        params
    })
}

// 代理商审核
export const proxyAuditApply = (data) => {
    return request({
        url: '/base/adm/cooperationApply/proxyAuditApply',
        method: 'post',
        data
    })
}

// 分销商审核
export const auditCooperationApply = (data) => {
    return request({
        url: '/base/adm/cooperationApply/auditCooperationApply',
        method: 'post',
        data
    })
}

// 修改合作状态
export const updateCompany = (data) => {
    return request({
        url: '/base/adm/company/updateCompany',
        method: 'post',
        data
    })
}

// 新增单位申请表
export const addCooperationApply = (data) => {
    return request({
        url: '/base/app/cooperationApply/addCooperationApply',
        method: 'post',
        data
    })
}

// 修改单位申请表
export const updateCompanyInfo = (data) => {
    return request({
        url: '/base/adm/companyInfo/updateCompanyInfo',
        method: 'post',
        data
    })
}

// 公司合同列表
export const getCompanyContractListPage = (params) => {
    return request({
        url: '/base/adm/companyContract/getListPage',
        method: 'get',
        params
    })
}

// 添加公司合同
export const addCompanyContract = (data) => {
    return request({
        url: '/base/adm/companyContract/addCompanyContract',
        method: 'post',
        data
    })
}

// 获取公司合同详情
export const getCompanyContract = (params) => {
    return request({
        url: '/base/adm/companyContract/getCompanyContract',
        method: 'get',
        params
    })
}

// 删除公司合同
export const delCompanyContract = (data) => {
    return request({
        url: '/base/adm/companyContract/delCompanyContract',
        method: 'post',
        data
    })
}

// 编辑公司合同
export const updateCompanyContract = (data) => {
    return request({
        url: '/base/adm/companyContract/updateCompanyContract',
        method: 'post',
        data
    })
}

// 管理员列表
export const getCompanyAdminUserPageList = (data) => {
    return request({
        url: '/base/adm/companyUser/getCompanyAdminUserPageList',
        method: 'post',
        data
    })
}

// 删除管理员
export const delUserAdminRoleToCompany = (data) => {
    return request({
        url: '/base/adm/companyUser/delUserAdminRoleToCompany',
        method: 'post',
        data
    })
}

// 添加管理员
export const addAdminToCompany = (data) => {
    return request({
        url: '/base/adm/companyUser/addAdminToCompany',
        method: 'post',
        data
    })
}

// 角色列表
export const proxyRole = (params) => {
    return request({
        url: '/base/proxyRole',
        method: 'get',
        params
    })
}

// 角色列表
export const subProxyRole = (params) => {
    return request({
        url: '/base/subProxyRole',
        method: 'get',
        params
    })
}

// 添加代理商角色
export const addProxyRole = (data) => {
    return request({
        url: '/base/role/addProxyRole',
        method: 'post',
        data
    })
}

// 添加分销商角色
export const addSubProxyRole = (data) => {
    return request({
        url: '/base/role/addSubProxyRole',
        method: 'post',
        data
    })
}

// 编辑角色
export const updateRole = (data) => {
    return request({
        url: '/base/role/update',
        method: 'post',
        data
    })
}

// 获取代理商菜单列表
export const getAuthorityproxyMenu = (params) => {
    return request({
        url: '/base/authority/proxyMenu',
        method: 'get',
        params
    })
}

// 获取分销商菜单列表
export const getAuthoritysubProxyMenu = (params) => {
    return request({
        url: '/base/authority/subProxyMenu',
        method: 'get',
        params
    })
}

// 获取功能列表
export const getAuthorityRole = (params) => {
    return request({
        url: '/base/authority/role',
        method: 'get',
        params
    })
}

// 分配权限
export const grantAuthorityRole = (data) => {
    return request({
        url: '/base/authority/role/grant',
        method: 'post',
        data
    })
}

// 分配代理商菜单
export const assignMenuToProxyCompany = (data) => {
    return request({
        url: '/base/company/assignMenuToProxyCompany',
        method: 'post',
        data
    })
}

// 分配分销商菜单
export const assignMenuToSubProxyCompany = (data) => {
    return request({
        url: '/base/company/assignMenuToSubProxyCompany',
        method: 'post',
        data
    })
}

// 菜单列表
export const getOmAll = (params) => {
    return request({
        url: 'base/menu/getOmAll',
        method: 'get',
        params
    })
}

// 驳回列表
export const getCompanyRejectReasonListPage = (params) => {
    return request({
        url: '/base/adm/companyRejectReason/getListPage',
        method: 'get',
        params
    })
}

// 添加驳回原因
export const addCompanyRejectReason = (data) => {
    return request({
        url: '/base/adm/companyRejectReason/addCompanyRejectReason',
        method: 'post',
        data
    })
}

// 审核合同
export const auditCompanyContract = (data) => {
    return request({
        url: '/base/adm/companyContract/auditCompanyContract',
        method: 'post',
        data
    })
}

// 驳回原因列表
export const getRejectedList = (params) => {
    return request({
        url: '/base/adm/contractRejectReason/getListPage',
        method: 'get',
        params
    })
}

// 平台总数据(超管)
export const getPlatformData = (data) => {
    return request({
      url: '/analyse/adm/orderCalData/getSuperPlatData',
      method: 'post',
      type: 'json',
      data
    })
}

// 平台总数据(超管)(代理商数据列表)
export const getPlatformDataList = (data) => {
    return request({
      url: '/analyse/adm/orderCalData/getSuperPlatAgentData',
      method: 'post',
      type: 'json',
      data
    })
}

// 平台总数据(代理商)
export const getAgentPlatformData = (data) => {
  return request({
    url: '/analyse/adm/orderCalData/getAgentPlatData',
    method: 'post',
    type: 'json',
    data
  })
}

// 平台总数据(分销商)
export const getDistributorPlatfromData = (data) => {
  return request({
    url: '/analyse/adm/orderCalData/getDistributorPlatData',
    method: 'post',
    type: 'json',
    data
  })
}

// 平台退款数据(超管)
export const getRefundPlatformData = (data) => {
    return request({
      url: '/order/adm/refundCalData/getSuperPlatData',
      method: 'post',
      type: 'json',
      data
    })
}

// 平台退款数据(超管)(代理商数据列表)
export const getRefundPlatformDataList = (data) => {
    return request({
      url: '/order/adm/refundCalData/getSuperPlatAgentData',
      method: 'post',
      type: 'json',
      data
    })
}

// 平台退款数据(代理商)
export const getAgentRefundPlatformData = (data) => {
  return request({
    url: '/order/adm/refundCalData/getAgentPlatData',
    method: 'post',
    type: 'json',
    data
  })
}

// 平台退款数据(分销商)
export const getDistributorRefundPlatfromData = (data) => {
  return request({
    url: '/order/adm/refundCalData/getDistributorPlatRefundData',
    method: 'post',
    type: 'json',
    data
  })
}

// 平台退款数据(分销商)
export const getContracts = () => {
  return request({
    url: '/order/adm/order/getContracts',
    method: 'post'
  })
}

// 平台退款数据(分销商)
export const bindContractId = (data) => {
  return request({
    url: '/base/adm/company/bindContractId',
    method: 'post',
    data
  })
}

// 设置分账比例
export const setAccountRate = (data) => {
  return request({
    url: '/base/adm/company/setAccountRate',
    method: 'post',
    data
  })
}


// 获取签约信息
export const getCompanySignInfo = (params) => {
  return request({
    url: '/base/adm/company/getCompanyById',
    method: 'get',
    params
  })
}
// 设置签约信息
export const updataeSignInfo = (data) => {
  return request({
    url: '/base/adm/company/updateSeal',
    method: 'post',
    data
  })
}
